import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions, { enableScrollingComponentVariant } from '../../../common/flex-options/flex-options.esm.js';
import spacingOptions from '../../../common/space-options/spacing-options.esm.js';

var autoSizeRootTV = getTvObject({
  base: ['absolute', 'inset-0', 'flex'],
  variants: _objectSpread2(_objectSpread2({
    direction: flexOptions.variants.direction,
    justify: flexOptions.variants.justify,
    alignItems: flexOptions.variants.alignItems,
    scrollable: flexOptions.variants.scrollable
  }, spacingOptions), {}, {
    compoundVariants: enableScrollingComponentVariant
  })
});
var autoSizeRootStyles = {
  base: tv(autoSizeRootTV)
};

export { autoSizeRootStyles, autoSizeRootTV };
//# sourceMappingURL=auto-size-root.styles.esm.js.map
